interface Props {
  data: string[][]
}

export function ChartSubHeader({ data }: Props) {
  return (
    <div className={tailwind.chartSubHeader}>
      <table className={tailwind.table}>
        <tbody>
          {data.map((row: string[], rowIndex: number) => (
            <tr key={rowIndex} className={tailwind.row}>
              {row.map((item: string, index: number) => (
                <td key={index}>{item}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

const tailwind = {
  chartSubHeader: 'text-black text-lg font-regular bg-[#DDD] py-1 pl-4 pr-4 w-full mb-5',
  table: 'table-fixed w-full',
  row: 'bg-[#DDD] w-full h-8 mb-5 px-4',
}
